import { d as b } from "./index-DH8DM7A9.mjs";
import { u as p } from "./use-screen-sizes-hx44ztp3.mjs";
import { useRef as r, useEffect as c, createContext as E, createRef as h, useContext as v, useMemo as y, useCallback as _ } from "react";
import { m as S } from "./index-BGgjYpYz.mjs";
import { d as L } from "./index-DspsydPg.mjs";
const x = ["MODAL", "INLINE_MODAL"], T = L.createLogger("@fabric/overlays"), s = [];
function k(e = "", t = S()) {
  x.includes(e) || T.warn(`Unknown overlay type pushed to stack. Type: "${e}"`);
  const n = { type: e, uid: t };
  return s.push(n), n;
}
function d(e) {
  const t = s.findIndex((n) => n.uid === e);
  if (t > -1) {
    const [n] = s.splice(t, 1);
    return n;
  }
}
function a(e) {
  return s.filter((t) => t.type === e).length;
}
function I(e, t) {
  const n = s.findIndex((o) => o.uid === e);
  n > -1 && (s[n].type = t);
}
function f(e, ...t) {
  const n = r([]);
  n.current = t, c(() => () => {
    e(...n.current);
  }, []);
}
function D(e, t) {
  const n = r("");
  n.current = e;
  const o = r("");
  c(() => {
    if (t) {
      const { uid: i } = k(n.current);
      o.current = i;
    } else
      d(o.current), o.current = "";
  }, [t]), c(() => {
    o.current && I(o.current, e);
  }, [e]), f((i) => {
    i && d(o.current);
  }, t);
}
const M = E({
  contentRef: h(),
  close: () => {
  },
  isOpen: !1
});
class w {
  constructor() {
    this.isEnabled = !0, this._boundHandleTransitionEnd = this._handleTransitionEnd.bind(this);
  }
  enableScroll() {
    this.isEnabled || (document.body.style.top = "", document.body.style.position = "", this._backdropElement && this._backdropElement.removeEventListener("transitionend", this._boundHandleTransitionEnd), window.scrollTo(0, this._scrollY)), this.isEnabled = !0;
  }
  disableScroll(t) {
    this.isEnabled && (this._scrollY = window.scrollY, document.body.style.top = `-${scrollY}px`, document.body.style.position = "fixed", this._backdropElement && this._backdropElement.removeEventListener("transitionend", this._boundHandleTransitionEnd), this._backdropElement = t, this._backdropElement && this._backdropElement.addEventListener("transitionend", this._boundHandleTransitionEnd)), this.isEnabled = !1;
  }
  _handleTransitionEnd(t) {
    t.propertyName === "opacity" && (document.body.style.top = "", t.target.removeEventListener("transitionend", this._boundHandleTransitionEnd));
  }
}
const C = [
  'input:not([type="hidden"]):not(:disabled)',
  "textarea:not(:disabled)",
  '.fab-Select [role="button"]:not(:disabled)',
  "select:not(:disabled)",
  "button:not(:disabled)"
].join();
function Y(e) {
  const t = e ? e.querySelector(C) : null;
  t && window.setTimeout(() => t.focus());
}
function l(e) {
  e.preventDefault();
}
const u = new w();
function N(e) {
  const t = r();
  return y(() => (e && (t.current = b.getMaxZIndex() + 10), t.current), [e]);
}
function U(e, t, n) {
  c(() => {
    const o = a("MODAL");
    e && (t && o === 1 && n ? u.disableScroll(n) : !t && o === 0 && u.enableScroll());
  }, [e, t, n]), f(
    (o, i) => {
      const m = a("MODAL");
      o && i && m === 0 && u.enableScroll();
    },
    t,
    e
  );
}
function B() {
  const e = r(), t = _((n) => n.preventDefault(), []);
  return c(
    () => () => {
      e.current && e.current.removeEventListener("submit", l);
    },
    [e, t]
  ), (n) => {
    n && (e.current = n, n.addEventListener("submit", l));
  };
}
function F() {
  const { isOpen: e } = v(M);
  return p(e);
}
function P() {
  return r(null);
}
export {
  M as B,
  N as a,
  P as b,
  B as c,
  D as d,
  U as e,
  Y as f,
  F as u
};
//# sourceMappingURL=hooks-DlFaCTNC.mjs.map
